import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=5fe1296c&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=ts&"
export * from "./DownloadButton.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=5fe1296c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1296c",
  null
  
)

export default component.exports